export default "__VITE_ASSET__ba076bed__"